const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://1btg4uv32b.execute-api.us-west-2.amazonaws.com/prod',
    TARGET_API_URL: 'https://hdhzvnj4qe.execute-api.us-west-2.amazonaws.com/api',
    TEAMS_APP_URL: 'https://teams.dev.platform.forwoodsafety.com/teams',
    QS_DASHBOARD_URL: '',
    CLIENT_TIMEZONE: 'America/Sao_Paulo'
  },
  reactApp: {
    VERSION: 'targets-1.11.0',
    HOSTNAME: 'https://targets.dev.platform.forwoodsafety.com'
  }
};

export default config;